
/**
 * 判断 字符串全部是汉字 或 英文字母
 */
const ValidateUtility = {}
ValidateUtility.validateName = function (name) {
    const result = {}
    result.istrue = false
    result.iswhich = '0'
    const reghan = /^[\u4e00-\u9fa5\·]*$/
    const regeng = /^[a-zA-Z\·\. \uFF00-\uFFFF]*$/
    if (reghan.test(name)) {
        result.istrue = true
        result.iswhich = '1'  // 1 是指汉字
        let henlen
        const reg = new RegExp('·', 'g')
        const arr = name.match(reg)
        if (arr != null && arr !== '' && arr.length > 0) {
            henlen = (arr.length) + (name.length - arr.length) * 2
        } else {
            henlen = name.length * 2
        }

        result.henlen = henlen
    }
    if (regeng.test(name)) {
        result.istrue = true
        result.iswhich = '2' // 2 是指英文
        result.englen = name.length
    }
    return result
}
//判断手机号
ValidateUtility.mobilephone = function (name) {
    const result = {}
    result.istrue = false;
    const reghans = /^1[3|4|5|6|7|8|9][0-9]{9}$/

    if (reghans.test(name)) {
        result.istrue = true
        result.englen = name.length
    }

    return result
}

/**
* 判断名称
*/
ValidateUtility.placename = function (name) {
    const result = {}
    result.istrue = false
    result.iswhich = '0'
    const reghan = /^(?:[\u4e00-\u9fa5]*\w*\s*)+$/
    if (reghan.test(name)) {
        result.istrue = true
        result.iswhich = '1'  // 1 是指汉字
    }

    return result
}
/**
* 判断证件
*/
ValidateUtility.card = function (name) {
    const result = {}
    result.istrue = false
    result.iswhich = '0'
    const reghan = /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/
    //const regeng = /^[a-zA-Z\·\. \uFF00-\uFFFF]*$/
    if (reghan.test(name)) {
        result.istrue = true
    }

    return result
}
/**
 * 判断邮箱
 */
ValidateUtility.email = function (name) {
    const result = {}
    result.istrue = false
    result.iswhich = '0'
    const reghan = /^([0-9A-Za-z\-_\.]+)@([0-9a-z]+\.[a-z]{2,3}(\.[a-z]{2})?)$/
    if (reghan.test(name)) {
        result.istrue = true
    }

    return result
}
/**
 * 判断长度大于10
 */
ValidateUtility.income = function (name) {
    const result = {}
    result.istrue = false
    result.iswhich = '0'
    const reghan = /^[0-9]{0,10}$/
    if (reghan.test(name)) {
        result.istrue = true
    }

    return result
}
/**
* 判断最大长度30
*/
ValidateUtility.contact = function (name) {
    const result = {}
    result.istrue = false
    result.iswhich = '0'
    const reghan = /^(?:[\u4e00-\u9fa5]{0,30}\w*\s*)$/
    if (reghan.test(name)) {
        result.istrue = true
        result.iswhich = '1'  // 1 是指汉字
    }

    return result
}
/**
* 判断年龄
*/
ValidateUtility.age = function (name) {
    const result = {}
    result.istrue = false
    result.iswhich = '0'
    const reghan = /^[0-9]{0,2}$/
    //const regeng = /^[a-zA-Z\·\. \uFF00-\uFFFF]*$/
    if (reghan.test(name)) {
        result.istrue = true
        result.iswhich = '1'  // 1 是指汉字
        let henlen
        const reg = new RegExp('·', 'g')
        const arr = name.match(reg)


        result.henlen = henlen
    }

    return result
}
/*
* 根据证件号获取性别: 1 男；2 女；
*/
ValidateUtility.getGenderById = function (card_id) {
    let flag = null
    if (card_id.length === 15) {
        flag = parseInt(card_id.substr(14, 1)) % 2 === 1
    } else if (card_id.length === 18) {
        flag = parseInt(card_id.substr(16, 1)) % 2 === 1
    }
    if (flag) {
        return '1'
    } else {
        return '2'
    }
}
/**
 * 根据身份证or户口本号码获取出生日期
 */
ValidateUtility.getBirthdayById = function (card_id) {
    let birthday = ''
    if (card_id != null && card_id != "") {
        if (card_id.length == 15) {
            birthday = '19' + card_id.substr(6, 6)
        } else if (card_id.length == 18) {
            birthday = card_id.substr(6, 8);
        }

        birthday = birthday.replace(/(.{4})(.{2})/, "$1-$2-")
    }
    return birthday
}


export default ValidateUtility





// WEBPACK FOOTER //
// ./src/pages/recruit/officeSaff/js/validator.js